export const getPageNumber = (page: string): number => Number(page) || 1;

export const isValidURL = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol === 'https:') {
      return true;
    }
    return false;
  } catch {
    return false;
  }
};
